export default __webpack_public_path__ + "static/media/bg-foundation-complete.325231e2.svg";